module.exports = __webpack_public_path__ + "img/dropsmith-logo-learn-from-nature.425d3378.png";